"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const withMap_1 = __importDefault(require("./withMap"));
const _utility_1 = require("./_utility");
const InforObj = [];
const markerCount = [];
const MarkerComponent = react_1.memo((props) => {
    const { position = props.mapCenter || { lat: 0, lng: 0 }, address, onChange, clickable, draggable, content, map, setMarkerLatLng, } = props;
    const [marker, setMarker] = react_1.useState();
    const handleEvent = (e) => {
        onChange && onChange({ lat: e.latLng.lat(), lng: e.latLng.lng() });
    };
    const closeOtherInfo = () => {
        if (InforObj.length > 0) {
            InforObj[0].set('marker', null);
            InforObj[0].close();
            InforObj.length = 0;
        }
    };
    react_1.useEffect(() => {
        if (map) {
            const markerObject = new google.maps.Marker({
                map,
                draggable,
                clickable,
            });
            setMarker(markerObject);
            markerCount.push(markerObject);
            markerObject.addListener('dragend', handleEvent);
            if (content && clickable) {
                const infoObject = new google.maps.InfoWindow({
                    content: content,
                });
                markerObject.addListener('click', function () {
                    closeOtherInfo();
                    infoObject.open(map, markerObject);
                    InforObj[0] = infoObject;
                });
            }
        }
        // eslint-disable-next-line
    }, [map, address, clickable, content, draggable]);
    react_1.useEffect(() => {
        if (marker) {
            if (_utility_1.isCoordinate(position)) {
                marker.setPosition(position);
                setMarkerLatLng && setMarkerLatLng(position, markerCount.length);
            }
        }
    }, [position, marker, setMarkerLatLng]);
    return react_1.default.createElement(react_1.default.Fragment, null);
});
exports.default = withMap_1.default(MarkerComponent);
